import {
  useTotalMobilityServicedCommunities,
} from '@src/modules/performance/context/reports-api-hooks';

import { Link, Text } from '@chakra-ui/react';
import ReportSection from './ReportSection';

const informationSource = {
  title: 'Total Mobility Communities',
  content: [
    {
      title: 'Serviced communities included',
      description:
  <Text fontSize="inherit" mb={2}>
    A list of the serviced communities for the selected network. The serviced communities applicable to each network have been determined by Road Efficiency Group Te Ringa Maimoa based on the NZTA links to the Public Transport Authorities that are available from
    {' '}
    <Link href="https://www.nzta.govt.nz/travelling-on-our-roads/public-transport/travelling-with-a-disability" isExternal>Travelling with a disability.</Link>
  </Text>,
      source:
  <Text fontSize="inherit" as="span">
    Sourced from
    {' '}
    <Link href="https://www.nzta.govt.nz/planning-and-investment/learning-and-resources/transport-data/data-and-tools/" isExternal>NZTA Data and Tools, use - total mobility</Link>
  </Text>,
    },
  ],
};

function PublicTransportTotalMobilityCommunities() {
  const { data, isLoading } = useTotalMobilityServicedCommunities();

  return (
    <ReportSection
      title="Total Mobility Communities"
      isLoading={isLoading}
      informationSource={informationSource}
      lockYear={data?.[0]?.LockYear}
    >
      <Text mb={4} fontSize="xs">Serviced communities included:</Text>
      {data?.map((community) => (
        <Text key={community.ServicedCommunity} fontSize="sm" fontWeight="bold">{community.ServicedCommunity}</Text>
      ))}
      {data?.some((x) => !x.ServicedCommunity) && (
        <Text fontSize="sm" fontWeight="bold">None listed</Text>
      )}
    </ReportSection>
  );
}

export default PublicTransportTotalMobilityCommunities;
